import type { HelpFile } from '../../types/help'
import { SystemsTestIds } from '../../../testids/SystemsTestIds'

export const systemsHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [SystemsTestIds.systemsList]:
      'Every target system connected to the IAM platform. Each entry is a downstream application or directory where access is provisioned.',
    [SystemsTestIds.btnNewSystem]:
      'Create a new target system of the locked type. Required attributes are derived from the type\u2019s attribute definitions.',
  },
}
